import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const serviceAreas = ['Katy', 'Cypress', 'Rosenberg', 'Richmond', 'Fulshear', 'Sealy', 'Sugar Land', 'Missouri City'];
export function ServiceAreaSection() {
  return <section id="service-area" className="py-16 md:py-24 bg-[#f9f7f2]" data-id="element-279">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-281">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#2D5A27]/10 text-[#2D5A27] mb-6" data-id="element-282">
            <MapPin className="w-8 h-8" data-id="element-283" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-4" data-id="element-284">
            OUR SERVICE AREAS
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-285">
            Proudly serving the greater Houston area. If you're nearby, we've
            got you covered.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-286">
          {/* Service Areas List */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-1" data-id="element-287">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-288">
              <h3 className="text-xl font-bold text-[#1B2E1B] mb-6" data-id="element-289">
                Areas We Serve
              </h3>
              <div className="grid grid-cols-2 gap-3" data-id="element-290">
                {serviceAreas.map((area, index) => <motion.div key={area} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.05
              }} className="flex items-center gap-2" data-id="element-291">
                    <MapPin className="w-4 h-4 text-[#2D5A27] flex-shrink-0" data-id="element-292" />
                    <span className="text-gray-700 font-medium" data-id="element-293">{area}</span>
                  </motion.div>)}
              </div>
              <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-294">
                <p className="text-sm text-gray-500" data-id="element-295">
                  Don't see your area? Call us — we may still be able to help!
                </p>
                <a href="tel:8325034445" className="inline-flex items-center mt-3 text-[#2D5A27] font-bold hover:text-[#C5A55A] transition-colors" data-id="element-296">
                  832-503-4445
                </a>
              </div>
            </div>
          </motion.div>

          {/* Google Maps Embed */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="lg:col-span-2" data-id="element-297">
            <div className="rounded-2xl overflow-hidden shadow-sm border border-gray-100 aspect-[4/3] lg:aspect-[16/10]" data-id="element-298">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d250000!2d-95.85!3d29.65!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="RMorales Lawn Service - Service Areas" className="w-full h-full" data-id="element-299" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}